import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// 🚀 IMPORTANDO O NOSSO RADAR
import NotificationRadar from "../components/NotificationRadar";

const SuperAdminRoute = ({ children }) => {
  const { currentUser, userInfo, loading } = useAuth();

  if (loading) {
    return null; 
  }

  // Se não há usuário logado, fail-close imediato apagando o rastro (replace)
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // 🛡️ BLINDAGEM FAIL-CLOSED: Se não tiver a role de superadmin e não for interno, bloqueia.
  const isSuper = userInfo?.role === "superadmin";
  const isInternal = userInfo?.isInternal === true;

  if (!isSuper && !isInternal) {
    // Envia de volta para o ambiente padrão/login se tentar bancar o esperto
    return <Navigate to="/" replace />;
  }

  // Se passou na validação da Elite, porta liberada! 
  // Renderizamos a tela solicitada (children) E o Radar invisível operando no fundo
  return (
    <>
      {children}
      <NotificationRadar />
    </>
  );
};

export default SuperAdminRoute;